export default class Capabilities {
	constructor () {
		this.pickers = {}
		this.selectedConfiguration = {
			isDevice: false,
			isRealDevice: false,
			browserName: '',
			browserVersion: '',
			deviceName: '',
			platform: '',
			codeType: 'javascript'
		}
		this.addHandlers()
		if (window.tbCodeTemplate && window.tbCodeTemplate.default) {
			this.showDefaultCode()
		}
	}

	addHandlers () {
		const dropdownMenus = document.querySelectorAll('.tb-selection-trigger')
		dropdownMenus.forEach((dropdownMenu) => {
			const menuId = dropdownMenu.getAttribute('data-menu')
			const codeType = dropdownMenu.getAttribute('data-codeType')
			this.selectedConfiguration.codeType = codeType
			const apiUrl = dropdownMenu.getAttribute('data-apiUrl') || '/support/picker/web-automate.json'
			const osFamily = dropdownMenu.getAttribute('data-initial-osFamily') || 'windows'
			const osName = dropdownMenu.getAttribute('data-initial-osName') || 'Windows 11'
			const browserName = dropdownMenu.getAttribute('data-initial-browserName') || 'chrome'
			const browserVersion = dropdownMenu.getAttribute('data-initial-browserVersion')
			const deviceName = dropdownMenu.getAttribute('data-initial-deviceName') || undefined
			const deviceVersion = dropdownMenu.getAttribute('data-initial-deviceVersion') || undefined

			if (!this.pickers[menuId]) {
				this.pickers[menuId] = new window.EnvironmentPicker(menuId, {
					osFamily: osFamily,
					osName: osName,
					browserName: browserName,
					browserVersion: browserVersion,
					deviceName: deviceName,
					deviceVersion: deviceVersion
				}, apiUrl)
				this.pickers[menuId].setClickHandler(this.onVersionClick.bind(this))
			}

			dropdownMenu.addEventListener('click', (e) => {
				this.pickers[menuId].toggle()
			})
		})
	}

	showDefaultCode () {
		const templateCode = window.tbCodeTemplate.default
		document.querySelector('#capCode code').innerHTML = hljs.highlight(templateCode, { language: this.selectedConfiguration.codeType }).value
	}

	capitalizeFirstLetter (val) {
		return String(val).charAt(0).toUpperCase() + String(val).slice(1)
	}

	onVersionClick (data) {
		if (data.deviceName) {
			this.selectedConfiguration.isRealDevice = data.isRealDevice || false
			this.selectedConfiguration.isDevice = true
			this.selectedConfiguration.deviceName = data.deviceName
			this.selectedConfiguration.browserVersion = data.deviceVersion
			let deviceManufacturer = this.capitalizeFirstLetter(data.osFamily)
			if (deviceManufacturer === 'Ios') {
				deviceManufacturer = 'iOS'
			}
			document.querySelectorAll('.tb-label-os').forEach(label => {
				label.innerHTML = `${deviceManufacturer} ${data.deviceVersion}`
			})
			const platformUrl = this.getOSIcon(data.osFamily)
			document.querySelectorAll('.tb-os-icon').forEach(img => {
				if (img.src !== platformUrl) {
					img.src = platformUrl
				}
			})
			if (data.osFamily === 'android') {
				this.selectedConfiguration.browserName = 'chrome'
				this.selectedConfiguration.platform = 'Android'
				const browserUrl = '/assets/environments/svg/chrome.svg'
				document.querySelectorAll('.tb-browser-icon').forEach(img => {
					if (img.src !== browserUrl) {
						img.src = browserUrl
					}
				})
			} else {
				this.selectedConfiguration.browserName = 'safari'
				this.selectedConfiguration.platform = 'iOS'
				const browserUrl = '/assets/environments/svg/safari.svg'
				document.querySelectorAll('.tb-browser-icon').forEach(img => {
					if (img.src !== browserUrl) {
						img.src = browserUrl
					}
				})
			}
			document.querySelectorAll('.tb-label-browser').forEach(label => {
				label.innerHTML = data.deviceName
			})
		} else {
			this.selectedConfiguration.isDevice = false
			this.selectedConfiguration.browserName = data.browser
			this.selectedConfiguration.browserVersion = data.browserVersion
			this.selectedConfiguration.platform = data.osName
			document.querySelectorAll('.tb-label-os').forEach(label => {
				label.innerHTML = data.osName
			})
			document.querySelectorAll('.tb-label-browser').forEach(label => {
				label.innerHTML = `${this.capitalizeFirstLetter(data.browser)} ${data.browserVersion}`
			})
			const platformUrl = this.getOSIcon(data.osFamily)
			document.querySelectorAll('.tb-os-icon').forEach(img => {
				if (img.src !== platformUrl) {
					img.src = platformUrl
				}
			})
			const browserUrl = data.browserIconUrl
			document.querySelectorAll('.tb-browser-icon').forEach(img => {
				if (img.src !== browserUrl) {
					img.src = browserUrl
				}
			})
		}

		this.showCode()
	}

	translatePlatformName (platformName) {
		if (platformName === 'Ubuntu') {
			return 'LINUX'
		}

		return platformName
	}

	translateBrowserName (browserName) {
		if (browserName === 'edge') {
			return 'MicrosoftEdge'
		}

		return browserName
	}

	getOptionsClass (browserName) {
		const optionsClasses = {
			'chrome': 'ChromeOptions',
			'firefox': 'FirefoxOptions',
			'safari': 'SafariOptions',
			'edge': 'EdgeOptions',
			'ie': 'InternetExplorerOptions',
			'internet explorer': 'InternetExplorerOptions'
		}
		return optionsClasses[browserName] || 'ChromeOptions'
	}

	getOSIcon(osFamily) {
		const icons = {
			'windows': '/assets/environments/svg/windows11.svg',
			'macos': '/assets/environments/svg/ios.svg',
			'linux': '/assets/environments/svg/linux.svg',
			'ios': '/assets/environments/svg/ios.svg',
			'android': '/assets/environments/svg/android.svg'
		}
		return icons[osFamily] || '/assets/environments/svg/windows11.svg'
	}

	showCode () {
		let templateCode = ''
		if (this.selectedConfiguration.isRealDevice) {
			templateCode = window.tbCodeTemplate.realMobile
		} else if (this.selectedConfiguration.isDevice) {
			templateCode = window.tbCodeTemplate.mobile
		} else {
			templateCode = window.tbCodeTemplate.desktop
		}
		templateCode = templateCode.replaceAll('%optionsClass%', this.getOptionsClass(this.selectedConfiguration.browserName))
		templateCode = templateCode.replaceAll('%browser%', this.translateBrowserName(this.selectedConfiguration.browserName))
		templateCode = templateCode.replaceAll('%platformName%', this.translatePlatformName(this.selectedConfiguration.platform))
		// Frameworks whose config wants a lowercase platform (mobilewright's `platform: 'ios'`).
		templateCode = templateCode.replaceAll('%platformNameLower%', this.translatePlatformName(this.selectedConfiguration.platform).toLowerCase())
		templateCode = templateCode.replaceAll('%version%', this.selectedConfiguration.browserVersion)
		templateCode = templateCode.replaceAll('%deviceName%', this.selectedConfiguration.deviceName)
		document.querySelector('#capCode code').innerHTML = hljs.highlight(templateCode, { language: this.selectedConfiguration.codeType }).value
	}
}
